import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { Nullable } from '@aibees/shared/definition';
import { forEach } from 'lodash-es';
import {
  EmailItem,
  PeopleEmail,
  PeopleEmailStatus,
  PeopleTableInfo,
} from '../../types';
import { isJobChangeHappened } from '../people-drawer/components/contact-details/utils';

export function isVerifyingEmails(item?: PeopleTableInfo) {
  return item?.revelation?.email?.state === ENRICHMENT_STATE.PROCESSING;
}

export function getLastVerificationDate(emails?: Nullable<PeopleEmail>) {
  let lastVerifiedDate = emails?.created
    ? new Date(emails?.created).getTime()
    : 0;

  forEach(getEmailsCleared(emails), (item) => {
    if (item.status !== PeopleEmailStatus.NOT_FOUND) {
      lastVerifiedDate = new Date(item.date).getTime();
    }
  });

  if (lastVerifiedDate) return lastVerifiedDate;

  return undefined;
}

export function isAnyEmailNeedsReverification(emails?: Nullable<PeopleEmail>) {
  const now = new Date().getTime();
  let lastVerifiedDate = emails?.created
    ? new Date(emails?.created).getTime()
    : undefined;

  let isThereAnyVerifiedEmail = false;

  forEach(getEmailsCleared(emails), (item) => {
    lastVerifiedDate = new Date(item.date).getTime();
    if (item.status === PeopleEmailStatus.VALID) isThereAnyVerifiedEmail = true;
  });

  return !!(
    emails?.state !== ENRICHMENT_STATE.PROCESSING &&
    isThereAnyVerifiedEmail &&
    lastVerifiedDate &&
    lastVerifiedDate + 86400000 < now
  );
}

// todo: refactor this function to a hook
export function howManyEmailsFound(
  emails?: EmailItem[],
  options?: { countInvalid?: boolean }
) {
  const notCountableEmailStatuses = [
    PeopleEmailStatus.ERROR,
    PeopleEmailStatus.INVALID,
    PeopleEmailStatus.NOT_FOUND,
    PeopleEmailStatus.UNKNOWN,
    PeopleEmailStatus.DOMAIN_NOT_FOUND,
    PeopleEmailStatus.DOMAIN_NOT_EXIST,
    PeopleEmailStatus.DOMAIN_NOT_ACCEPT,
    PeopleEmailStatus.DO_NOT_MAIL,
  ];

  const invalidStatusesList = options?.countInvalid
    ? notCountableEmailStatuses.filter(
        (status) => status !== PeopleEmailStatus.INVALID
      )
    : notCountableEmailStatuses;

  let count = 0;

  forEach(emails, (item) => {
    if (!invalidStatusesList.includes(item.status)) count += 1;
  });
  return count;
}

export function getEmailType(item: EmailItem) {
  return 'Work';
  // NOTICE: for now we just have work emails, until the back-end do some update for personal emails
  // return item.free ? 'Work' : 'Personal';
}

export function getEmailKind(index: number, compact: boolean) {
  if (index === 0) return compact ? 'P' : 'Primary';
  if (index === 1) return compact ? 'S' : 'Secondary';
  return compact ? 'O' : 'Other';
}

export function getEmailsCleared(emails?: Nullable<PeopleEmail>) {
  if (typeof emails?.content === 'string') {
    emails.content = JSON.parse(emails.content);
  }
  const tempList = emails?.content?.filter(
    (email) =>
      email.status !== PeopleEmailStatus.ERROR &&
      email.status !== PeopleEmailStatus.NOT_FOUND &&
      email.status !== PeopleEmailStatus.UNKNOWN &&
      email.status !== PeopleEmailStatus.DOMAIN_NOT_FOUND &&
      email.status !== PeopleEmailStatus.DOMAIN_NOT_EXIST &&
      email.status !== PeopleEmailStatus.DOMAIN_NOT_ACCEPT &&
      email.status !== PeopleEmailStatus.DO_NOT_MAIL
  );

  if (tempList?.length) {
    return tempList;
  }
  return [
    {
      address: 'Email Not Found',
      status: PeopleEmailStatus.NOT_FOUND,
      free: false,
      found: false,
      new: false,
      date: '0',
      score: 0,
    },
  ] as EmailItem[];
}

export function getEmailQucikInfoStatus(emails?: EmailItem[]) {
  const statuses = emails?.map((i) => i.status);
  if (statuses?.includes(PeopleEmailStatus.VALID))
    return PeopleEmailStatus.VALID;
  if (statuses?.includes(PeopleEmailStatus.CATCH_ALL))
    return PeopleEmailStatus.CATCH_ALL;
  if (statuses?.includes(PeopleEmailStatus.INVALID))
    return PeopleEmailStatus.INVALID;

  return PeopleEmailStatus.LOCKED;
}

export function isEmailBelongsToPreviousCompanies(data?: PeopleTableInfo) {
  if (!data) return false;
  const emails = getEmailsCleared(data.revelation?.email);
  const emailsFound = !!howManyEmailsFound(emails, { countInvalid: true });
  if (!emailsFound) return false;

  return isJobChangeHappened(data);

  // ? the below code is not used for now, but we can use it in the future based on the changes
  // ? on the back-end business of job change and how it relates to the email

  // const currentCompanyDomain = data.company?.link?.domain?.toLowerCase();

  // if (!currentCompanyDomain) return false;

  // let matchedEmail = false;

  // for (const email of emails) {
  //   if (
  //     email.address.endsWith(removePathFramUrl(cleanUrl(currentCompanyDomain)))
  //   )
  //     matchedEmail = true;
  // }

  // let alreadyCheckedForUpdate = false;

  // if (!matchedEmail) {
  //   alreadyCheckedForUpdate = hasAnyExpiredEmail(data);
  // }

  // return !matchedEmail && !alreadyCheckedForUpdate;
}
